var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar-menu',{attrs:{"menu":_vm.menu,"showOneChild":"true"}},[_c('span',{attrs:{"slot":"dropdown-icon"},slot:"dropdown-icon"},[_c('i',{staticClass:"fa fa-angle-down fa-lg",attrs:{"aria-hidden":"true"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }